import { useEffect, useState } from "react";
import SelectedDetails from "./SelectedDetails";
const API_KEY = "f7cb3a66b84cc5a6c86ec358b6f7af76";
export default function Selected(props){
    // eslint-disable-next-line
    let id = props.match.params.id;
    console.log(id);
    console.log(props);
    const URL = "https://api.themoviedb.org/3/movie/"+id+"?api_key="+API_KEY+"&language=en-US&append_to_response=videos";
    let [data, setData] = useState([]);
    let [bg, setBg] = useState("");
    let getData = async ()=>{
        let movie = await (await fetch(URL)).json();
        console.log(movie);
        setData([movie]);
        setBg(movie.backdrop_path);
    }
    useEffect(()=>{
        console.log("pasoook");
        getData();
        // eslint-disable-next-line
    },[id]);
    return(
        <div className="selected-container" style={{backgroundImage: 'url(http://image.tmdb.org/t/p/w500/' + bg  + ')'}}>
            <div className="blackDiv"></div>
            {data.map(e=>{
                  return <SelectedDetails key={e.id} ratings={e.vote_average} picture={"http://image.tmdb.org/t/p/w500/"+e.poster_path} movieName={e.title} tagline={e.tagline} desc={e.overview} genres={e.genres} trailer={e.videos.results[0].key} />
              })
            }
        </div>
     
    )
}